import React from 'react';

const Support = () => {
  return (
    <div>
      <h2>Support</h2>
      <p>
          If you find an issue, please report it on <a href="https://github.com/bootstrapbay/lazy-kit-react">our GitHub repo</a>. In this way, we can repair the bug and update the code base for all the people that are using the kit.
      </p>
      <p>
        You can also please visit <a href="https://bootstrapbay.com/user/BootstrapBay">our profile page</a> and send us a message or ask a question at <a href="mailto:contact@bootstrapbay.com?subject=LazyKitReact">contact@bootstrapbay.com</a>.
      </p>
    </div>
  );
};

export default Support;
